<template>
    <div class="vue-navbar-dropdown relative">
        <span v-on:click="open = !open" class="hidden sm:flex items-center text-gray-500 hover:text-indigo-600 font-medium text-sm cursor-pointer">
            <span v-text="label"></span>
            <svg width="8" height="6" fill="none" class="ml-2.5 text-gray-400">
                <path d="M7 1.5l-3 3-3-3" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"></path>
            </svg>
        </span>
        <div v-show="open" class="origin-top-right absolute right-0 mt-2 w-48 rounded-md shadow-lg py-1 bg-white ring-1 ring-black ring-opacity-5 focus:outline-none" role="menu" aria-orientation="vertical" aria-labelledby="user-menu-button" tabindex="-1">
            <div class="divide-y divide-gray-100">
                <slot></slot>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        props: ['label'],
        data: function() {
            return {
                open: false,
            };
        },
        mounted: function() {
            //
        },
        computed: {
            //
        },
        methods: {
            //
        }
    }
</script>
